import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

import { useTranslation } from 'react-i18next';

interface RefreshButtonProps {
  onClick: () => void;
  loading?: boolean;
  className?: string;
  'aria-label'?: string;
  title?: string;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  onClick,
  loading = false,
  className = '',
  'aria-label': ariaLabel = 'Refresh',
  title = 'Refresh',
}) => {
  const { t } = useTranslation('pleri/shared');

  return (
    <button
      onClick={onClick}
      className={`rounded p-1 hover:bg-gray-200 dark:hover:bg-gray-600 ${loading ? 'cursor-wait opacity-70' : ''} ${className}`}
      aria-label={ariaLabel}
      title={title}
      aria-busy={loading}
      disabled={loading}
      data-testid="refresh-button"
      type="button"
    >
      <span className="sr-only">{loading ? t('refreshing') : title}</span>
      <ArrowPathIcon
        className={`h-5 w-5 text-gray-500 dark:text-gray-400 ${loading ? 'animate-spin' : ''}`}
      />
    </button>
  );
};

export default RefreshButton;
